export default __webpack_public_path__ + "static/media/jackpot.533c30da.mp3";